export default "__VITE_ASSET__7306a6bb__"